import isApiError from "@insite/client-framework/Common/isApiError";
import { del } from "@insite/client-framework/Services/ApiService";

const url = "/api/v1/osnEmailSubscription";

export async function unsubscribeOsnService(email: string) {
    const queryParams = `?email=${email}`;
    try {
        const result = await del(`${url}${queryParams}`);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}